module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.tooltip)+'" role="tooltip"> <div class="'+(props.styles.tooltipInner)+'" data-playable-hook="tooltip-inner"></div></div>';return out;
} 
  };